export const TEAM_TYPES = {
  BUSINESS: 'Business',
  PERSONAL: 'Personal',
}

export const BUDGETING_PERIODS = {
  WEEK: 'week',
  MONTH: 'month',
}

export const ENTITY_TYPES = {
  VAULT: 'vault',
  VAULT_GROUP: 'vault_group',
  TRANSACTION_CATEGORY: 'transaction_category',
  TRANSACTION_CATEGORY_GROUP: 'transaction_category_group',
  MONEY_IN_HEADER: 'money_in_header',
  MONEY_OUT_HEADER: 'money_out_header',
}

export const TRANSACTION_TYPES = {
  STANDARD: 'Standard',
  BALANCE: 'Balance',
  TRANSFER: 'Transfer',
}

export const TRANSACTION_DIRECTION = {
  MONEY_IN: 'MoneyIn',
  MONEY_OUT: 'MoneyOut',
}

export const PANEL_STATES = {
  OPENED: 'opened',
  CLOSED: 'closed',
}

export const MODAL_WINDOW_STATE = {
  OPENED: 'opened',
  CLOSED: 'closed',
}

export const MODAL_WINDOW_TYPE = {
  ARCHIVE_VAULT: 'archive_vault',
  ARCHIVE_CATEGORY: 'archive_category',
  ARCHIVE_EMPTY_CATEGORY: 'archive_empty_category',
  UNABLE_TO_ARCHIVE: 'unable_to_archive',
  EMPTY_VAULT_ARCHIVE: 'empty_vault_archive',
  CREATE_MODEL: 'create_model',
  CONFIRMATION_MODAL: 'confirmation_modal',
}

export const ARCHIVE_STEP = {
  FIRST: 'first',
  SECOND: 'second',
}

export const NON_MODAL_WINDOW_STATE = {
  OPENED: 'opened',
  CLOSED: 'closed',
}

export const NON_MODAL_WINDOW_TYPE = {
  VAULT: 'vault',
  EDIT_VAULT: 'edit_vault',
  TRANSACTION_CATEGORY_INCOME: 'income',
  TRANSACTION_CATEGORY_EXPENSE: 'expenses',
  EDIT_INCOME: 'edit_income',
  EDIT_EXPENSE: 'edit_expense',
  TRANSACTION: 'transaction',
  EDIT_GROUP: 'edit_group',
  MODELS: 'models',
  MODELS_WINDOW: 'models_window',
}

export const SETUP_STEPS = {}
